// src/hooks/useCoinSync.js
import { useEffect } from 'react';
import useCoinStore from '../stores/coinStore';
import authService from '../Services/authService';
import paystackService from '../Services/paystackService';

// Custom hook to initialize coin store
const useCoinSync = () => {
  const { syncBalance, isStale } = useCoinStore();

  useEffect(() => {
    // Sync on app load if data is stale
    if (isStale()) {
      syncBalance();
    }

    const retryPayments = () => {
      if (!authService.auth.currentUser) return;
      paystackService
        .retryPendingPayments()
        .then((granted) => granted > 0 && syncBalance())
        .catch(() => {});
    };
    // Auth restores asynchronously; retry once it's ready, then with each sync.
    const firstRetry = setTimeout(retryPayments, 4000);

    // Optional: Set up periodic sync (every 5 minutes)
    const interval = setInterval(() => {
      if (isStale()) {
        syncBalance();
      }
      retryPayments();
    }, 5 * 60 * 1000); // 5 minutes

    return () => {
      clearTimeout(firstRetry);
      clearInterval(interval);
    };
  }, [syncBalance, isStale]);
};

export default useCoinSync;